import React, { Component } from 'react';

import Header from '../decoration/header';
import OrderPageProgressBar from '../decoration/orderPageProgressBar';
import CartListPanel from './cartListPanel';

import Footer from '../footer/footer';

import './orderPage1.css';

class OrderPage1 extends Component {
	render() {
		return (
			<div>
				<Header />
				<OrderPageProgressBar index="1" />
				<CartListPanel />
				<Footer />
			</div>
		);
	}
}

export default OrderPage1;



// WEBPACK FOOTER //
// ./src/components/orderPage1/orderPage1.js